import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import ConnectedFormControl from '../FormControl/FormControl.js';

const ToggleIcon = ({ onClick , className , isActive , isDisabled  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("button", {
        type: "button",
        "aria-label": isActive ? getLabel('account.hidePassword') : getLabel('account.showPassword'),
        onClick: onClick,
        disabled: isDisabled,
        className: className
    }, isActive ? /*#__PURE__*/ React.createElement(Icon, {
        name: "eye-slash"
    }) : /*#__PURE__*/ React.createElement(Icon, {
        name: "eye"
    }));
};
class Password extends (React.Component) {
    render() {
        const _props = this.props, { label , errorMessage  } = _props, rest = swcHelpers.objectWithoutProperties(_props, [
            "label",
            "errorMessage"
        ]);
        const { passwordVisible  } = this.state;
        return /*#__PURE__*/ React.createElement("div", {
            className: "password-container"
        }, /*#__PURE__*/ React.createElement(ConnectedFormControl, swcHelpers.extends({}, ConnectedFormControl.defaultProps, {
            id: "password",
            "data-t": "password",
            "aria-describedby": rest['aria-describedby'],
            type: passwordVisible ? 'text' : 'password',
            label: label,
            className: "form-control--password",
            errorMessage: errorMessage
        }, rest)), /*#__PURE__*/ React.createElement(ToggleIcon, {
            onClick: this.onVisibilityToggle,
            className: "password-toggle",
            isActive: passwordVisible
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            passwordVisible: false
        };
        this.onVisibilityToggle = ()=>{
            this.setState((prevState)=>({
                    passwordVisible: !prevState.passwordVisible
                })
            );
        };
    }
}
Password.defaultProps = {
    required: true,
    validations: []
};

export { Password as default };
//# sourceMappingURL=Password.js.map
